import styled from "styled-components/macro";
import { Link } from "react-scroll";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

export const LoginHeading = styled.h2`
  color: #000000;
  font-size: 1.4rem;
  opacity: 1;
  font-weight: 600;
  font-family: "Montserrat";
  letter-spacing: 0px;

  text-align: ${({ alignCenter }) => (alignCenter ? "center" : defaultLanguage === "ar" ? "right" : "left")};

  @media screen and (max-width: 768px) {
    font-size: 1.2em;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.1em;
  }

  @media screen and (max-width: 425px) {
    font-size: 1em;
  }

  @media screen and (max-width: 375px) {
    font-size: 0.8em;
  }
`;

export const LoginButton = styled.button`
  margin-top: 0.4em;
  border-radius: 2px;
  width: 100%;
  white-space: nowrap;
  padding: ${({ big }) => (big ? "0.5em 2em" : "0.7em 1.5em")};
  background: ${({ primary }) => (primary ? "transparent" : "#ED7D2B")};
  border: 1px solid ${({ primary }) => (primary ? "#FFFFFF" : "#ED7D2B")};
  color: ${(dark) => (dark ? "#F1F1F1" : "#F1F1F1")};
  font-size: ${({ fontBig }) => (fontBig ? "1.2rem" : "0.9rem")};
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  border-radius: 4px;

  /* &:hover {
            transition: all 0.2s ease-in-out;
            background: ${({ primary }) => (primary ? "#FF4001" : "transparent")};
            border: 1px solid ${({ primary }) => (primary ? "#FF4001" : "#FFFFFF")};
            color: ${(dark) => (dark ? "#F1F1F1" : "#F1F1F1")};
        } */

  @media screen and (max-width: 768px) {
    margin: 0.5em;
    margin-left: 0;
    padding: ${({ big }) => (big ? "0.5em 2em" : "0.6em 1.5em")};
    font-size: ${({ fontBig }) => (fontBig ? "1.2em" : "0.9em")};
  }

  @media screen and (max-width: 480px) {
    margin: 0.5em;
    margin-left: 0;
    padding: ${({ big }) => (big ? "0.5em 2em" : "0.4em 1.2em")};
    font-size: ${({ fontBig }) => (fontBig ? "1.2em" : "0.8em")};
  }
`;

export const LoginPara = styled.p`
  text-align: ${({ alignCenter }) => (alignCenter ? "center" : "left")};
  font-size: 1rem;
  font-weight: 400;
  color: #8e8e8f;
`;

export const LoginDetails = styled.p`
  display: flex;
  flex-direction: column;
`;

export const SearchIcon = styled.span`
  width: 8%;
  padding: 5px;
  text-align: center;
  color: #000000;
  /* font-size: 20px; */
  /* background: #f0f0f0; */
  border-radius: 8px 0px 0px 8px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PartitionSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 20px;

  @media screen and (max-width: 480px) {
    margin-top: 0.4rem;
    margin-bottom: 0.4rem;
  }
`;

export const PartitionSectionP = styled.div`
  border-bottom: 1px solid #d3d3d3;
  width: 42%;
  margin-bottom: 0.6rem;
`;

export const SocialContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.8rem;
`;

export const SocialBtn = styled.button`
  width: 100px;
  height: 44px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 10px #00000026;
  border-radius: 10px;
  opacity: 1;
  border: none;
  margin-left: 20px;
`;

export const SocialBtnGoogle = styled.button`
  padding: ${({ socialSize }) => (socialSize ? "0.4rem 3rem" : "0.4rem 2.5rem")};
  background: #f5f6fa 0% 0% no-repeat padding-box;
  border: 1px solid #ececec;
  border-radius: 4px;
  opacity: 1;
  border: none;

  @media screen and (max-width: 480px) {
    padding: 0.4rem 1.5rem;
  }

  @media screen and (max-width: 375px) {
    padding: 0.4rem 1.2rem;
  }
`;

export const SocialBtnApple = styled.button`
  padding: ${({ socialSize }) => (socialSize ? "0.4rem 3rem" : "0.4rem 2.5rem")};
  background: #000000 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  border: none;
  margin-left: 20px;

  @media screen and (max-width: 480px) {
    padding: 0.4rem 1.5rem;
  }

  @media screen and (max-width: 375px) {
    padding: 0.4rem 1.2rem;
  }
`;

export const SocialBtnFb = styled.button`
  padding: ${({ socialSize }) => (socialSize ? "0.4rem 3rem" : "0.4rem 2.5rem")};
  padding: 0.5rem 2.5rem;
  background: #1876f0 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  border: none;
  margin-left: 20px;

  @media screen and (max-width: 480px) {
    padding: 0.4rem 1.5rem;
  }

  @media screen and (max-width: 375px) {
    padding: 0.4rem 1.2rem;
  }

  /* @media screen and (max-width: 425px) {
        padding : 0.4rem 1rem
    } */

  /* @media screen and (max-width: 375px) {
        padding : 0.4rem 0.6rem
    } */
`;

export const GuestLoginBtn = styled.button`
  background: #fdf2e9 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  border: none;
  margin-left: 20px;
  cursor: pointer;
  padding: 0.6rem 0.9rem;
  white-space: nowrap;
`;
export const GuestLoginText = styled.div`
  font: 500 15px/24px Montserrat;
  color: #ed7d2b;
  opacity: 1;
  letter-spacing: 0px;
`;

export const InputLabel = styled.div`
  text-align: ${defaultLanguage === "ar" ? "right" : "left"};
  font-size: 0.9rem;
  color: #000000;
  ${"" /* font: normal normal medium 18px/24px Montserrat; */}
  letter-spacing: 0px;
  opacity: 1;
  font: var(--unnamed-font-style-normal) normal medium 18px / var(--unnamed-line-spacing-24) Montserrat;
  @media (max-width: 426px) {
    font-size: 0.8rem;
  }
`;

export const SigninWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: auto;
  width: auto;
  direction: ${defaultLanguage === "ar" ? "rtl" : "ltr"};
`;

export const SigninBorder = styled.div`
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 1.5rem;
`;

export const SigninText = styled.div`
  font-size: 0.9rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-right: ${defaultLanguage === "ar" ? "0" : "1.7rem"};
  margin-left: ${defaultLanguage === "ar" ? "1.7rem" : "0"};
  padding: 0.6rem 0rem;
  cursor: pointer;
  border-bottom: ${({ logintype }) => (logintype ? "2px solid #eb7d35" : "")};
  font-weight: ${({ logintype }) => (logintype ? "600" : "")};
  color: ${({ logintype }) => (logintype ? "#000000" : "#7F7F7F")};
`;

export const NewAccountText = styled.div`
  color: #7f7f7f;
  font-weight: 400;
  font-size: 0.9rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  opacity: 1;
  cursor: pointer;
  /* border-bottom : 2px solid #eb7d35; */
  border-bottom: ${({ logintype }) => (logintype ? "2px solid #eb7d35" : "")};
  font-weight: ${({ logintype }) => (logintype ? "600" : "")};
  color: ${({ logintype }) => (logintype ? "#000000" : "#7F7F7F")};
  padding: 0.6rem 0rem;
`;

export const ProfileBox = styled.div`
  height: auto;
  width: auto;
  /* background-color: lightskyblue; */
  border-radius: 50%;
`;
export const ProfileImg = styled.img`
  height: 48px;
  width: 48px;
  border-radius: 50%;
  object-fit: cover;

  @media screen and (max-width: 835px) {
    height: 40px;
    width: 40px;
  }
  @media screen and (max-width: 768px) {
    height: 34px;
    width: 34px;
  }
`;

export const SocialImg = styled.img`
  width: 85%;

  @media screen and (max-width: 375px) {
    width: 90%;
  }
`;

export const PartitionOR = styled.span`
  letter-spacing: 0px;
  color: #7e7e80;
  opacity: 1;
  font-weight: 400;
  font-size: 0.8rem;
  font-family: "Montserrat";
`;

export const AcceptTerm = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  opacity: 1;
  width: 100%;
  margin: 0.5rem 0rem;
`;
export const TermText = styled.div`
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-weight: 500;
  font-size: 0.8rem;
  font-family: "Montserrat";
  margin-left: ${defaultLanguage === "ar" ? "0" : "0.7rem"};;
  margin-right: ${defaultLanguage === "ar" ? "0.7rem" : "0"};;
  /* margin-right: 0.7rem; */
`;

export const TermLink = styled(Link)`
  letter-spacing: 0px;
  color: #004cff;
  opacity: 1;
  text-decoration: none;
  font-weight: 400;

  &:hover {
    color: #fd9900;
  }
`;

export const ForgetPara = styled.div`
  font-size: 0.9rem;
  font-weight: 400;
  color: #202020;
  opacity: 0.5;
  color: #1d1d20;
  letter-spacing: 0px;
  margin: 0.2rem 0;
`;

export const ForgetHeading = styled.h2`
  font-size: 1.3rem;
  font-weight: 500;
  opacity: 1;
  color: #000000;
  letter-spacing: 0px;
`;

export const FlagImg = styled.img``;

export const ForgePara = styled.div`
  text-align: ${defaultLanguage === "ar" ? "right" : "left"};
  font-size: 0.9rem;
  font-weight: 400;
  color: #8e8e8f;
`;

export const OtpButton = styled.button`
  margin: 0.4em;
  border-radius: 2px;
  width: 80%;
  white-space: nowrap;
  padding: ${({ big }) => (big ? "0.5em 2em" : "0.7em 1.5em")};
  background: ${({ primary }) => (primary ? "transparent" : "#ED7D2B")};
  border: 1px solid ${({ primary }) => (primary ? "#FFFFFF" : "#ED7D2B")};
  color: ${(dark) => (dark ? "#F1F1F1" : "#F1F1F1")};
  font-size: ${({ fontBig }) => (fontBig ? "1.2rem" : "1rem")};
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  border-radius: 4px;

  /* &:hover {
            transition: all 0.2s ease-in-out;
            background: ${({ primary }) => (primary ? "#FF4001" : "transparent")};
            border: 1px solid ${({ primary }) => (primary ? "#FF4001" : "#FFFFFF")};
            color: ${(dark) => (dark ? "#F1F1F1" : "#F1F1F1")};
        } */

  @media screen and (max-width: 768px) {
    margin: 0.5em;
    margin-left: 0;
    padding: ${({ big }) => (big ? "0.5em 2em" : "0.6em 1.5em")};
    font-size: ${({ fontBig }) => (fontBig ? "1.2em" : "0.9em")};
  }

  @media screen and (max-width: 480px) {
    margin: 0.5em;
    margin-left: 0;
    padding: ${({ big }) => (big ? "0.5em 2em" : "0.4em 1.2em")};
    font-size: ${({ fontBig }) => (fontBig ? "1.2em" : "0.8em")};
  }
`;

export const FormNextButton = styled.div`
  color: #ed7d2b;
  font-size: 1rem;
  font-weight: 400;
  /* text-decoration: underline */
  cursor: pointer;

  &:hover {
    color: blue;
  }
  /* &:focus {
  background: #d16b21;
} */
  @media (max-width: 769px) {
    font-size: 0.8rem;
  }
`;
